import { createSelector } from 'reselect';

import { coworkingFlexibleWorkplaceWithErrorSelector } from './coworkingFlexibleWorkplaceWithErrorSelector';

export const coworkingFlexibleWorkplacePriceSelector = createSelector(
  coworkingFlexibleWorkplaceWithErrorSelector,
  flexible => flexible.price,
);
